/**
 * Reopen the consent / "privacy choices" UI provided by NitroPay's CMP.
 *
 * The CMP only exists once NitroPay's ad script (ads-XXXX.js) is loaded on the
 * page — which is gated behind the `ads` feature flag and pending NitroPay
 * onboarding. Until that script is installed, none of these globals exist, so
 * callers should treat a `false` return as "no CMP yet" and fall back to the
 * privacy policy.
 *
 * TODO(nitropay): once the script is installed, confirm the exact resurface
 * call from NitroPay's onboarding docs and prune the branches that don't apply.
 */
export function resurfaceConsent() {
    if (typeof window === 'undefined') {
        return false;
    }

    // NitroPay-specific hook, if/when exposed on window.nitroAds.
    if (window.nitroAds && typeof window.nitroAds.openConsent === 'function') {
        window.nitroAds.openConsent();
        return true;
    }

    // Legacy IAB TCF v1 CMP — some CMPs still expose this to reopen the tool.
    if (typeof window.__cmp === 'function') {
        window.__cmp('showConsentTool');
        return true;
    }

    return false;
}
